import React, {HTMLProps, useEffect, useState} from 'react';
import {searchStore} from './store';

const DeleteIcon = (props: HTMLProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1rem"
    height="1rem"
    {...props}
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M1 3.80005H2.55556H15"
      stroke="#9BAAB8"
      strokeWidth="1.55556"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4446 3.8V13.6C13.4446 13.9713 13.2807 14.3274 12.9889 14.5899C12.6972 14.8525 12.3016 15 11.889 15H4.11122C3.69866 15 3.303 14.8525 3.01128 14.5899C2.71955 14.3274 2.55566 13.9713 2.55566 13.6V3.8M4.889 3.8V2.4C4.889 2.0287 5.05289 1.6726 5.34461 1.41005C5.63633 1.1475 6.03199 1 6.44455 1H9.55566C9.96822 1 10.3639 1.1475 10.6556 1.41005C10.9473 1.6726 11.1112 2.0287 11.1112 2.4V3.8"
      stroke="#9BAAB8"
      strokeWidth="1.55556"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.44434 7.30005V11.5"
      stroke="#9BAAB8"
      strokeWidth="1.55556"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.55566 7.30005V11.5"
      stroke="#9BAAB8"
      strokeWidth="1.55556"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none">
    <path
      d="M10.5 4L3.5 11"
      stroke="#5F6975"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 4L10.5 11"
      stroke="#5F6975"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SearchItem = (props: {
  data: string;
  setText: (text: string) => void;
  onCancel: (data: any) => void;
}) => {
  const {data, setText, onCancel} = props;
  return (
    <div className="flex items-center justify-between gap-3 bg-[#e4e7f2] p-2 rounded-sm">
      <span
        className="text-sm font-medium text-t2 flex-1 overflow-ellipsis overflow-hidden"
        onClick={() => setText(data)}>
        {data}
      </span>
      <div onClick={() => onCancel(data)}>
        <CloseIcon />
      </div>
    </div>
  );
};

export function SearchHistory({setText}: {setText: (text: string) => void}) {
  const [list, setList] = useState<string[]>([]);
  const handleClear = (data: string) => {
    searchStore.removeSearchQuery(data);
  };
  const clearAll = () => {
    searchStore.clearSearchHistory();
  };
  useEffect(() => {
    searchStore.loadFromStorage();
    searchStore.onHistoryChange(() => {
      setList(searchStore.getSearchHistory());
    });
  }, []);
  // 获取当前缓存中的数据
  return list.length ? (
    <div className="bg-gradient-to-b from-white to-white/0 mb-4">
      <div className="flex items-center p-3 justify-between">
        <div className="text-t1 text-sm font-bold">Search History</div>
        {list.length === 0 ? null : <DeleteIcon onClick={clearAll} />}
      </div>
      <div className="px-3 grid grid-cols-3 gap-2">
        {list.map(item => {
          return (
            <SearchItem data={item} setText={setText} onCancel={handleClear} />
          );
        })}
      </div>
    </div>
  ) : null;
}
